// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchInput--1OQOLM80 {\n  border-radius: 3px;\n  width: 270px;\n  height: 32px;\n  padding-right: 10px;\n  padding-left: 13px;\n}\n.searchIcon--TC4NqEJP {\n  position: absolute;\n  top: 9px;\n  left: 249px;\n  color: #bfbfbf;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchInput": "searchInput--1OQOLM80",
	"searchIcon": "searchIcon--TC4NqEJP"
};
export default ___CSS_LOADER_EXPORT___;
